import { mapDTO } from '@twistezo/ts-dto-mapper'

import { floatPercentFromDTO } from 'utils/number'
import { DomainViewabilityTools } from '../../types/domainViewabilityTools'
import { DomainViewabilityToolsDTO } from '../types/domainViewabilityToolsDTO'

export const domainViewabilityToolsFromDTO = (
  from: DomainViewabilityToolsDTO,
): DomainViewabilityTools =>
  mapDTO<DomainViewabilityToolsDTO, DomainViewabilityTools>({ from }).transform(
    (dvtDTO: DomainViewabilityToolsDTO): DomainViewabilityTools => {
      const {
        createdAt,
        gamAdRenderMargin,
        gamAdRequestMargin,
        kvTargetingAndPrebidAuction,
        trafficAffected,
        updatedAt,
      } = dvtDTO

      return {
        ...dvtDTO,
        createdAt: new Date(createdAt),
        gamAdRenderMargin: floatPercentFromDTO(gamAdRenderMargin),
        gamAdRequestMargin: floatPercentFromDTO(gamAdRequestMargin),
        kvTargetingAndPrebidAuction: floatPercentFromDTO(kvTargetingAndPrebidAuction),
        trafficAffected: floatPercentFromDTO(trafficAffected),
        updatedAt: new Date(updatedAt),
      }
    },
  )
